export default "__VITE_ASSET__51562b08__"